import Extend from 'flarum/common/extenders';
import AcceptedSpecies from './models/AcceptedSpecies';
import NewSpecies from './models/NewSpecies';
import ParentSpecies from './models/ParentSpecies';
import RemovedSpecies from './models/RemovedSpecies';
import SynonymSpecies from './models/SynonymSpecies';
export default [new Extend.Store().add('champis-species-accepted', AcceptedSpecies).add('champis-species-new', NewSpecies).add('champis-species-parent', ParentSpecies).add('champis-species-removed', RemovedSpecies).add('champis-species-synonym', SynonymSpecies)];